export class AccountCountryLegalRequirements {
    public countryCode: number;
    public isoCode: string;
    public friendlyName: string;
    public registrationDataRequirements: string[];
    public documentType: string[];
    public requiresIdentificationProof: boolean;
}